import uiTriggered, { UITriggeredOption } from './Actions/UI.Triggered.action'
import hitGTM from './Actions/GTM.action'

export type UIAction = {

  uiTriggered(action: UITriggeredOption): void,

  hitGTM(type: string, extraPayload?: {}): void,

}

const uiActionCreators: UIAction = {
  uiTriggered,
  hitGTM,
}

export default uiActionCreators
